<template>
  <v-container>
    <v-row dense>
      <v-col cols="12">
        <v-card color="basil" flat outlined>
          <v-card-title v-if="customer.id">
            <h3 class="font-weight-bold text-uppercase" >{{customer.NombreCompleto}}</h3>
          </v-card-title>
          <v-card-subtitle>
            <h4 class="font-weight-bold" ><span class="black--text">Tel.:</span> {{customer.telefono}}</h4>
            <h4 class="font-weight-bold" ><span class="black--text">Correo:</span> {{customer.correo}}</h4>
          </v-card-subtitle>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-layout justify-center align-center>
                  <v-btn-toggle v-model="tipoIngresos.solicitud" class="buttonBorder"
                    color="deep-purple accent-3 pa-4" tile dense group>
                    <v-btn value="asalariado"> Asalariado </v-btn>
                    <v-btn value="independiente"> Honorarios </v-btn>
                    <v-btn value="personaFisica"> PFAE O MORAL </v-btn>
                  </v-btn-toggle>
                </v-layout>
              </v-col>
              <v-col cols="12">
                <v-layout justify-center align-center>
                  <h2 class="text-center pa-4">INGRESOS COMPROBABLES Y DEUDAS DE CREDITO</h2>
                </v-layout>
              </v-col>

              <v-col cols="6">
                <v-row dense class="black--text font-weight-bold">
                  <v-col cols="11">
                    <v-text-field
                      v-model.number="tipoIngresos.ingresoMensualNeto"
                      label="INGRESO MENSUAL NETO"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense/>
                  </v-col>
                  <v-col cols="11">
                    <v-text-field
                      v-model.number="tipoIngresos.ingresoMensualComprobables"
                      label="OTROS INGRESOS MENSUALES COMPROBABLES"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense/>
                  </v-col>
                  <v-col cols="11">
                    <v-text-field
                      v-model.number="tipoIngresos.ingresoMensualFamiliar"
                      label="INGRESO MENSUAL NETO CON FAMILIAR O PAREJA"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row dense class="black--text font-weight-bold">
                  <v-col cols="11">
                    <v-text-field
                      v-model="tipoIngresos.tarjetaCreditoBancos"
                      label="PAGO TDC BANCARIO (MESES SIN INTERESES)"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense/>
                  </v-col>
                  <v-col cols="11">
                    <v-text-field
                      v-model="tipoIngresos.tarjetaCreditoComercial"
                      label="PAGO TDC COMERCIAL (MESES SIN INTERESES)"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense/>
                  </v-col>
                  <v-col cols="11">
                    <v-text-field
                      v-model="tipoIngresos.pagoMensualAuto"
                      label="PAGO MENSUAL DE AUTOMOVIL"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="11">
                    <v-text-field
                      v-model="tipoIngresos.pagoMensualHipoteca"
                      label="PAGO MENSUAL DE HIPOTECA"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense/>
                  </v-col>
                  <v-col cols="11">
                    <v-text-field
                      v-model="tipoIngresos.pagoMensualNomina"
                      label="PAGO MENSUAL CREDITO NOMINA U OTROS"
                      type="number"
                      prefix="$"
                      min="0"
                      :readonly="isreadonly"
                      outlined
                      dense/>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="6">
                <v-row dense class="black--text font-weight-bold">
                  <v-col cols="11">
                    <v-text-field
                      v-model="totalIngresos"
                      label="TOTAL INGRESOS"
                      type="number"
                      prefix="$"
                      min="0"
                      readonly
                      outlined
                      dense/>
                  </v-col>
                  <v-col cols="11">
                    <v-text-field
                      v-model="totalIngresosMenostotalAdeudos"
                      label="TOTAL INGRESOS - ADEUDOS"
                      type="number"
                      prefix="$"
                      min="0"
                      readonly
                      outlined
                      dense/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row dense class="black--text font-weight-bold">
                  <v-col cols="11">
                    <v-text-field
                      v-model="totalAdeudos"
                      label="TOTAL ADEUDOS"
                      type="number"
                      prefix="$"
                      min="0"
                      readonly
                      outlined
                      dense/>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12">
                <v-card width="auto" tile>
                  <v-toolbar dense dark color="blue darken-2">
                    <v-toolbar-title>
                      <h3 class="text-center text-p">CAPACIDAD DE CREDITO</h3>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout justify-center>
                      <v-flex md10>
                        <v-row dense>
                          <v-col cols="6" class="text-center mt-4">
                            <label class="font-weight-black black--text title"> Credito Aproximado: </label>
                            <span class="font-weight-bold title"> $ {{intlRound(CreditoAprox)}}</span>
                          </v-col>
                          <v-col cols="6" class="text-center mt-4">
                            <label class="font-weight-black black--text title">Pago Disponible para el Credito: </label>
                            <span class="font-weight-bold title"> $ {{intlRound(pagoDisponible)}}</span>
                          </v-col>
                          <p class="text-p black--text subtitle-1 mt-4">* Estos datos son aproximaciones de caracter informativo, no garantizan el otorgamiento del credito</p>
                        </v-row>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>

              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end class="px-4">
              <v-btn color="red darken-2" class="mr-4" @click="cancel" dark> Salir </v-btn>
              <v-btn color="green darken-2" @click="send" dark> Guardar </v-btn>
            </v-layout>
          </v-card-actions>
          </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import { NumberUtils } from '@/mixins/NumberUtilsMixin'
import router from '@/router'
export default {
  mixins: [Validate, NumberUtils],
  data: () => ({
    customer_id: 0,
    tipoIngresos: {
      solicitud: '',
      ingresoMensualNeto: 0,
      ingresoMensualComprobables: 0,
      ingresoMensualFamiliar: 0,

      tarjetaCreditoBancos: 0,
      tarjetaCreditoComercial: 0,
      pagoMensualAuto: 0,
      pagoMensualHipoteca: 0,
      pagoMensualNomina: 0
    },
    customer: {},
    isreadonly: false
  }),
  components: {},
  mounted () {
    if (this.$route.params.id) {
      this.customer_id = this.$route.params.id
      this.PostObject({ url: '/clientes', data: { id: this.customer_id } })
    }
  },
  methods: {
    ...mapActions(['PostObject', 'PostObjectSeccound']),
    cancel () {
      router.push({ name: 'ViewCustomers' })
    },
    send () {
      if (!this.tipoIngresos.solicitud && this.tipoIngresos.solicitud === '') {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia !',
          text: 'Tipo de credito no debes ser seleccionado'
        })
        return
      }
      this.tipoIngresos.cliente_id = this.customer_id
      this.PostObjectSeccound({ url: '/clientes/credito/actividad-economica', data: this.tipoIngresos })
    }
  },
  computed: {
    ...mapGetters(['get_object', 'get_objectSeccound']),
    // *==========*==========*==========*==========*==========*==========*==========*==========* \\
    // *==========*==========*==========* Actividad Economica *==========*==========*==========* \\
    // *==========*==========*==========*==========*==========*==========*==========*==========* \\
    totalIngresos () {
      if (this.tipoIngresos.solicitud !== '') {
        const ingresoMensualNeto = (this.tipoIngresos.ingresoMensualNeto === '') ? 0 : parseFloat(this.tipoIngresos.ingresoMensualNeto)
        const ingresoMensualComprobables = (this.tipoIngresos.ingresoMensualComprobables === '') ? 0 : parseFloat(this.tipoIngresos.ingresoMensualComprobables)
        const ingresoMensualFamiliar = (this.tipoIngresos.ingresoMensualFamiliar === '') ? 0 : parseFloat(this.tipoIngresos.ingresoMensualFamiliar)
        return (ingresoMensualNeto + ingresoMensualComprobables + ingresoMensualFamiliar)
      }
      return 0
    },
    totalAdeudos () {
      if (this.tipoIngresos.solicitud !== '') {
        const tarjetaCreditoBancos = (this.tipoIngresos.tarjetaCreditoBancos === '') ? 0 : parseFloat(this.tipoIngresos.tarjetaCreditoBancos)
        const tarjetaCreditoComercial = (this.tipoIngresos.tarjetaCreditoComercial === '') ? 0 : parseFloat(this.tipoIngresos.tarjetaCreditoComercial)
        const pagoMensualAuto = (this.tipoIngresos.pagoMensualAuto === '') ? 0 : parseFloat(this.tipoIngresos.pagoMensualAuto)
        const pagoMensualHipoteca = (this.tipoIngresos.pagoMensualHipoteca === '') ? 0 : parseFloat(this.tipoIngresos.pagoMensualHipoteca)
        const pagoMensualNomina = (this.tipoIngresos.pagoMensualNomina === '') ? 0 : parseFloat(this.tipoIngresos.pagoMensualNomina)

        return (tarjetaCreditoBancos + tarjetaCreditoComercial + pagoMensualAuto + pagoMensualHipoteca + pagoMensualNomina)
      }
      return 0
    },
    totalIngresosMenostotalAdeudos () {
      return (this.totalIngresos - this.totalAdeudos)
    },
    CreditoAprox () {
      let capacidad = 0
      if (this.tipoIngresos.solicitud === 'asalariado' || this.tipoIngresos.solicitud === 'independiente') {
        capacidad = (((this.totalIngresos * 0.60) - this.totalAdeudos) / 10) * 1000
      } else if (this.tipoIngresos.solicitud === 'personaFisica' || this.tipoIngresos.solicitud === 'Empresario') {
        const ingresoMensualNeto = (this.tipoIngresos.ingresoMensualNeto === '') ? 0 : parseFloat(this.tipoIngresos.ingresoMensualNeto)
        const ingresoMensualComprobables = (this.tipoIngresos.ingresoMensualComprobables === '') ? 0 : parseFloat(this.tipoIngresos.ingresoMensualComprobables)
        const ingresoMensualFamiliar = (this.tipoIngresos.ingresoMensualFamiliar === '') ? 0 : parseFloat(this.tipoIngresos.ingresoMensualFamiliar)
        const resultado = (ingresoMensualNeto * 0.60) + ingresoMensualComprobables + ingresoMensualFamiliar
        capacidad = (((resultado * 0.60) - this.totalAdeudos) / 10) * 1000
      }
      return capacidad
    },
    pagoDisponible () {
      return ((this.CreditoAprox * 10) / 1000)
    }
  },
  watch: {
    get_object (val) {
      if (val) {
        this.customer = val
      }
    },
    get_objectSeccound (val) {
      if (val.message) {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia !',
          text: 'Tipo de Ingreso no debes ser seleccionado'
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso !',
        text: 'Registro agregado correctamente',
        time: 1500
      })
      this.cancel()
    }
  }
}
</script>

<style>
.buttonBorder button {
  border: 1px #1976D2 solid !important;
  color: #1976D2 !important;
  font-weight: bold;
}
.text-p {
  margin: 0 auto;
}
.right-number {
  float: right;
}
.cuadro-blue {
  border: 1px #1976D2 solid !important;
  padding: 5px;
}
</style>
